import { useMemo } from 'react';
import { ContentBlockFieldOptions, CustomContent } from '../types';
import { getContentBlockField } from '../utils';

export const useContentBlockField = (
  customContent: CustomContent[],
  type: string,
  options: ContentBlockFieldOptions
) => {
  return useMemo(
    () =>
      getContentBlockField(
        customContent,
        type,
        options.router
          ? {
              slug: options.slug,
              router: options.router,
              previewPlaceholder: options.previewPlaceholder
            }
          : { slug: options.slug }
      ),
    [customContent, options.slug, options.previewPlaceholder, options.router, type]
  );
};
